/**
 * @fileoverview gRPC-Web generated client stub for childreporting
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: childreporting/childreporting.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var authz_annotations_pb = require('../authz/annotations_pb.js')

var artifact_artifact_pb = require('../artifact/artifact_pb.js')

var audit_auditbot_pb = require('../audit/auditbot_pb.js')

var common_model_pb = require('../common/model_pb.js')
const proto = {};
proto.childreporting = require('./childreporting_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.childreporting.ChildReportingServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.childreporting.ChildReportingServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.childreporting.GetChildControlExportsResponse>}
 */
const methodDescriptor_ChildReportingService_GetChildControlExports = new grpc.web.MethodDescriptor(
  '/childreporting.ChildReportingService/GetChildControlExports',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.childreporting.GetChildControlExportsResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.childreporting.GetChildControlExportsResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.childreporting.GetChildControlExportsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.childreporting.GetChildControlExportsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.childreporting.ChildReportingServiceClient.prototype.getChildControlExports =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/childreporting.ChildReportingService/GetChildControlExports',
      request,
      metadata || {},
      methodDescriptor_ChildReportingService_GetChildControlExports,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.childreporting.GetChildControlExportsResponse>}
 *     Promise that resolves to the response
 */
proto.childreporting.ChildReportingServicePromiseClient.prototype.getChildControlExports =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/childreporting.ChildReportingService/GetChildControlExports',
      request,
      metadata || {},
      methodDescriptor_ChildReportingService_GetChildControlExports);
};


module.exports = proto.childreporting;

